import ReportForm from './ReportForm.js'
import styles from './style.css'
import { connect } from 'react-redux'

class ReportDetail extends React.Component {
  render () {
    return (
      <div className={styles.wrapper}>
        <ReportForm
          onSubmit={this._onSubmit}
        />
      </div>
    )
  }

  _onSubmit = (values) => {
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

function mapStateToProps (state) {
  const {reports, reportDetail} = state.tableManagement.group
  return {
    reports,
    reportDetail
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ReportDetail)



// WEBPACK FOOTER //
// ./app/pages/TableManagement/TableManagementReport/ReportDetail/ReportDetail.js